import React, { createContext, useContext, useEffect, useReducer, useCallback } from 'react';
import { getBaseUrl } from './utils/apiConfig';

// Define the context
const WorkshopContext = createContext();
const baseUrl = getBaseUrl();

// Reducer function to manage state updates
function workshopReducer(state, action) {
  switch (action.type) {
    case 'set_workshops':
      return { ...state, workshops: action.payload };
    case 'select_workshop':
      return { ...state, selectedWorkshops: [...state.selectedWorkshops, action.payload] };
    case 'deselect_workshop':
      return { ...state, selectedWorkshops: state.selectedWorkshops.filter(id => id !== action.payload) };
    case 'set_selected':
        return { ...state, selectedWorkshopId: action.payload };
    case 'set_workshop_details':
      return { ...state, selectedWorkshopDetails: action.payload };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

// Provider component
export function WorkshopProvider({ children }) {
  const initialState = { 
    workshops: [],
    selectedWorkshops: [],
    selectedWorkshopId: null,
    selectedWorkshopDetails: null,
  };

  const [state, dispatch] = useReducer(workshopReducer, initialState);

  useEffect(() => {
    // Fetch workshops data
    fetch(`${baseUrl}/api/workshops`)
      .then(response => response.json())
      .then(data => dispatch({ type: 'set_workshops', payload: data }))
      .catch(error => console.error('Error fetching workshops:', error));
  }, []);

  const fetchWorkshopDetails = useCallback(async (workshopId) => {
    const response = await fetch(`${baseUrl}/api/workshops/${workshopId}`);
    const data = await response.json();
    dispatch({ type: 'set_workshop_details', payload: data });
  }, []);

  const value = { state, dispatch, fetchWorkshopDetails };

  return <WorkshopContext.Provider value={value}>{children}</WorkshopContext.Provider>;
}

// Custom hook to use the workshop context
export function useWorkshops() {
  const context = useContext(WorkshopContext);
  if (context === undefined) {
    throw new Error('useWorkshops must be used within a WorkshopProvider');
  }  
  return context;
}
